import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "green-successfull-tick",
  "use": "green-successfull-tick-usage",
  "viewBox": "0 0 49 48",
  "content": "<symbol viewBox=\"0 0 49 48\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"green-successfull-tick\">\n<path d=\"M48.5 24C48.5 37.2548 37.7548 48 24.5 48C11.2452 48 0.5 37.2548 0.5 24C0.5 10.7452 11.2452 0 24.5 0C37.7548 0 48.5 10.7452 48.5 24Z\" fill=\"#198155\" />\n<path d=\"M32.5 18.95L22.9142 28.5358C22.1332 29.3168 20.8668 29.3168 20.0858 28.5358L16.5 24.95\" stroke=\"white\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol